export default {
  isInsidePanel: state => state.isInsidePanel,
  externalPanels: state => state.externalPanels
}
